export default __webpack_public_path__ + "static/media/cert-content-bg.437c8ab1.png";